import "regenerator-runtime/runtime.js";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import { assembleLookbookQuery } from '~/helpers/extract-helper';
function fetchLookbook(_x, _x2) {
  return _fetchLookbook.apply(this, arguments);
}
function _fetchLookbook() {
  _fetchLookbook = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(context, query) {
    var locale, xhrUri, _yield$context$$axios, data;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          locale = context.state.i18n.currentLocale;
          xhrUri = "/catalog/v1/lookbooks/catalog?culture=".concat(locale.language, "_").concat(locale.market, "&").concat(assembleLookbookQuery(query));
          _context.next = 4;
          return context.$axios.get(xhrUri);
        case 4:
          _yield$context$$axios = _context.sent;
          data = _yield$context$$axios.data;
          return _context.abrupt("return", data);
        case 7:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _fetchLookbook.apply(this, arguments);
}
export { fetchLookbook as default };